module.exports = __webpack_public_path__ + "img/ico3.3a5a0f3d.png";